import { render, staticRenderFns } from "./Idefix.vue?vue&type=template&id=df6ade06&scoped=true"
import script from "./Idefix.vue?vue&type=script&lang=js"
export * from "./Idefix.vue?vue&type=script&lang=js"
import style0 from "./Idefix.vue?vue&type=style&index=0&id=df6ade06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6ade06",
  null
  
)

export default component.exports